 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER501LETTERFROMBEIJING from '@/components/0_chapter501letterfrombeijing'
 import A_CHAPTER502PHYSICALINFIRMITY from '@/components/1_chapter502physicalinfirmity'
 import A_CHAPTER503THEPRINCERETURNEDTOTHECAPITAL from '@/components/2_chapter503theprincereturnedtothecapital'
 import A_CHAPTER504THEPASTISLIKESMOKE from '@/components/3_chapter504thepastislikesmoke'
 import A_CHAPTER505VISITINGTHEQUEEN from '@/components/4_chapter505visitingthequeen'
 import A_CHAPTER506THEQUEENDIED from '@/components/5_chapter506thequeendied'
 import A_CHAPTER507RETURNONCHILD from '@/components/6_chapter507returnonchild'
 import A_CHAPTER508ARRIVALOFTHEEDICT from '@/components/7_chapter508arrivaloftheedict'
 import A_CHAPTER509SISTERHOOD from '@/components/8_chapter509sisterhood'
 import A_CHAPTER510THEPRINCERETURNEDTOTHECAPITAL from '@/components/9_chapter510theprincereturnedtothecapital'
 import A0_CHAPTER511MOTHERANDCHILDMEETING from '@/components/10_chapter511motherandchildmeeting'
 import A1_CHAPTER512PARTYINTHEMANSION from '@/components/11_chapter512partyinthemansion'
 import A2_CHAPTER513UNINVITEDGUEST from '@/components/12_chapter513uninvitedguest'
 import A3_CHAPTER514SELFDECEPTION from '@/components/13_chapter514selfdeception'
 import A4_CHAPTER515SNOW from '@/components/14_chapter515snow'
 import A5_CHAPTER516QUEENSBIRTHDAY from '@/components/15_chapter516queensbirthday'
 import A6_CHAPTER517BAREVOICE from '@/components/16_chapter517barevoice'
 import A7_CHAPTER518BIRTHDAYSTART from '@/components/17_chapter518birthdaystart'
 import A8_CHAPTER519SISTERMEETING from '@/components/18_chapter519sistermeeting'
 import A9_CHAPTER520PARTINGWARNING from '@/components/19_chapter520partingwarning'
 import A0_CHAPTER521SNOWNIGHTNEEDLING from '@/components/20_chapter521snownightneedling'
 import A1_CHAPTER522ONTHEWAYHOME from '@/components/21_chapter522onthewayhome'
 import A2_CHAPTER523QUOTIENTCOUNTERMEASURE from '@/components/22_chapter523quotientcountermeasure'
 import A3_CHAPTER524TALKINGBYCANDLEATNIGHT from '@/components/23_chapter524talkingbycandleatnight'
 import A4_CHAPTER525DEVELOPPLAN from '@/components/24_chapter525developplan'
 import A5_CHAPTER526UNQUENCHEDLIGHT from '@/components/25_chapter526unquenchedlight'
 import A6_CHAPTER527PALPITATION from '@/components/26_chapter527palpitation'
 import A7_CHAPTER528WHATISPEACEFULLIFE from '@/components/27_chapter528whatispeacefullife'
 import A8_CHAPTER529BONEANDFLESHDISINTEGRATION from '@/components/28_chapter529boneandfleshdisintegration'
 import A9_CHAPTER530SEARCHFOREVIDENCE from '@/components/29_chapter530searchforevidence'
 import A0_CHAPTER531MOTHERTOMOTHER from '@/components/30_chapter531mothertomother'
 import A1_CHAPTER532TRAPPEDINADILEMMA from '@/components/31_chapter532trappedinadilemma'
 import A2_CHAPTER533DISTINGUISHINGTRUTHFROMFALSEHOOD from '@/components/32_chapter533distinguishingtruthfromfalsehood'
 import A3_CHAPTER534SEEDIVIDE from '@/components/33_chapter534seedivide'
 import A4_CHAPTER535IDONTKNOWHOWDIFFICULTITISFORPARENTS from '@/components/34_chapter535idontknowhowdifficultitisforparents'
 import A5_CHAPTER536PROOF from '@/components/35_chapter536proof'
 import A6_CHAPTER537SELFDECEPTION from '@/components/36_chapter537selfdeception'
 import A7_CHAPTER538STOICHIOMETRICTOLERANCE from '@/components/37_chapter538stoichiometrictolerance'
 import A8_CHAPTER539PUTTINGANENDTOTHEPROBLEM from '@/components/38_chapter539puttinganendtotheproblem'
 import A9_CHAPTER540WHATISINYOURMIND from '@/components/39_chapter540whatisinyourmind'
 import A0_CHAPTER541MUSSELSTRUGGLE from '@/components/40_chapter541musselstruggle'
 import A1_CHAPTER542THEBEWILDERMENTOFRESUME from '@/components/41_chapter542thebewildermentofresume'
 import A2_CHAPTER543SHOW from '@/components/42_chapter543show'
 import A3_CHAPTER544QUOTIENTCOUNTERMEASURE from '@/components/43_chapter544quotientcountermeasure'
 import A4_CHAPTER545NOTIFYWUSHAN from '@/components/44_chapter545notifywushan'
 import A5_CHAPTER546NIGHTPLAY from '@/components/45_chapter546nightplay'
 import A6_CHAPTER547HEISABRAVEFIGHTER from '@/components/46_chapter547heisabravefighter'
 import A7_CHAPTER548TRYDETAIL from '@/components/47_chapter548trydetail'
 import A8_CHAPTER549REBELLION from '@/components/48_chapter549rebellion'
 import A9_CHAPTER550TEMPORARYNEGLECT from '@/components/49_chapter550temporaryneglect'
 import A0_CHAPTER551UNEXPECTED from '@/components/50_chapter551unexpected'
 import A1_CHAPTER552PAINFORALL from '@/components/51_chapter552painforall'
 import A2_CHAPTER553FAINT from '@/components/52_chapter553faint'
 import A3_CHAPTER554PLACEMENTOFXIAOYANG from '@/components/53_chapter554placementofxiaoyang'
 import A4_CHAPTER555LATERALFUJIN from '@/components/54_chapter555lateralfujin'
 import A5_CHAPTER556PLEADFORTHEFIFTHPRINCE from '@/components/55_chapter556pleadforthefifthprince'
 import A6_CHAPTER557HOME from '@/components/56_chapter557home'
 import A7_CHAPTER558THEGREATESTVIRTUEISFORGIVENESS from '@/components/57_chapter558thegreatestvirtueisforgiveness'
 import A8_CHAPTER559PLEADFORTHEFIFTHPRINCE from '@/components/58_chapter559pleadforthefifthprince'
 import A9_CHAPTER560ANGELHASA from '@/components/59_chapter560angelhasa'
 import A0_CHAPTER561THEETIQUETTEOFTHEJINDYNASTY from '@/components/60_chapter561theetiquetteofthejindynasty'
 import A1_CHAPTER562WUXUETANG from '@/components/61_chapter562wuxuetang'
 import A2_CHAPTER563VISITTOWESTRANGOON from '@/components/62_chapter563visittowestrangoon'
 import A3_CHAPTER564XIUHUANGSRESENTMENT from '@/components/63_chapter564xiuhuangsresentment'
 import A4_CHAPTER565CARDIACKNOT from '@/components/64_chapter565cardiacknot'
 import A5_CHAPTER566CAREANDRESPECT from '@/components/65_chapter566careandrespect'
 import A6_CHAPTER567QUARRELLING from '@/components/66_chapter567quarrelling'
 import A7_CHAPTER568GOHOMETOYOURPARENTS from '@/components/67_chapter568gohometoyourparents'
 import A8_CHAPTER569BEATPEACE from '@/components/68_chapter569beatpeace'
 import A9_CHAPTER570PREPAREFORWEDDING from '@/components/69_chapter570prepareforwedding'
 import A0_CHAPTER571ZHOUQUAN from '@/components/70_chapter571zhouquan'
 import A1_CHAPTER572HEART from '@/components/71_chapter572heart'
 import A2_CHAPTER573THEDAYSOFDESOLATION from '@/components/72_chapter573thedaysofdesolation'
 import A3_CHAPTER574BESTDOWRY from '@/components/73_chapter574bestdowry'
 import A4_CHAPTER575PHOENIXCORONETANDGOWN from '@/components/74_chapter575phoenixcoronetandgown'
 import A5_CHAPTER576ABIGSURPRISE from '@/components/75_chapter576abigsurprise'
 import A6_CHAPTER577BESTBLESSINGS from '@/components/76_chapter577bestblessings'
 import A7_CHAPTER578WHATDOESHAPPINESSMEAN from '@/components/77_chapter578whatdoeshappinessmean'
 import A8_CHAPTER579MISCHIEVOUSZUOYUAN from '@/components/78_chapter579mischievouszuoyuan'
 import A9_CHAPTER580GRANDMARRIAGE from '@/components/79_chapter580grandmarriage'
 import A0_CHAPTER581EMBARRASSMENT from '@/components/80_chapter581embarrassment'
 import A1_CHAPTER582RUNNINGWAVEEXHAUSTION from '@/components/81_chapter582runningwaveexhaustion'
 import A2_CHAPTER583LOVELYBRIDE from '@/components/82_chapter583lovelybride'
 import A3_CHAPTER584GROWTHOFTHECHILD from '@/components/83_chapter584growthofthechild'
 import A4_CHAPTER585SURPRISEFROMYINGER from '@/components/84_chapter585surprisefromyinger'
 import A5_CHAPTER586586GRANDFATHER from '@/components/85_chapter586586grandfather'
 import A6_CHAPTER587HAVEAGOODTIME from '@/components/86_chapter587haveagoodtime'
 import A7_CHAPTER588GOODINTENTIONS from '@/components/87_chapter588goodintentions'
 import A8_CHAPTER589SMALLQUARREL from '@/components/88_chapter589smallquarrel'
 import A9_CHAPTER590KINGOFTHESOUTHWEST from '@/components/89_chapter590kingofthesouthwest'
 import A0_CHAPTER591RUBBINGSALTINWOUND from '@/components/90_chapter591rubbingsaltinwound'
 import A1_CHAPTER592HEWASDELIGHTED from '@/components/91_chapter592hewasdelighted'
 import A2_CHAPTER593VISIT from '@/components/92_chapter593visit'
 import A3_CHAPTER594MOTHERSMISCHIEF from '@/components/93_chapter594mothersmischief'
 import A4_CHAPTER595LOVE from '@/components/94_chapter595love'
 import A5_CHAPTER596VISITZUOYUANYUAN from '@/components/95_chapter596visitzuoyuanyuan'
 import A6_CHAPTER597SCHOOLGIRL from '@/components/96_chapter597schoolgirl'
 import A7_CHAPTER598PREVIOUSCHAPTERNEXTCHAPTER from '@/components/97_chapter598previouschapternextchapter'
 import A8_CHAPTER599MARRED from '@/components/98_chapter599marred'
 import A9_CHAPTER600HYPERKINESISOFLIVERANDBLOOD from '@/components/99_chapter600hyperkinesisofliverandblood'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter501letterfrombeijing",
 			"name" : "0_chapter501letterfrombeijing",
 			"component" : A_CHAPTER501LETTERFROMBEIJING
 		},
 		{
 			"path" : "/1_chapter502physicalinfirmity",
 			"name" : "1_chapter502physicalinfirmity",
 			"component" : A_CHAPTER502PHYSICALINFIRMITY
 		},
 		{
 			"path" : "/2_chapter503theprincereturnedtothecapital",
 			"name" : "2_chapter503theprincereturnedtothecapital",
 			"component" : A_CHAPTER503THEPRINCERETURNEDTOTHECAPITAL
 		},
 		{
 			"path" : "/3_chapter504thepastislikesmoke",
 			"name" : "3_chapter504thepastislikesmoke",
 			"component" : A_CHAPTER504THEPASTISLIKESMOKE
 		},
 		{
 			"path" : "/4_chapter505visitingthequeen",
 			"name" : "4_chapter505visitingthequeen",
 			"component" : A_CHAPTER505VISITINGTHEQUEEN
 		},
 		{
 			"path" : "/5_chapter506thequeendied",
 			"name" : "5_chapter506thequeendied",
 			"component" : A_CHAPTER506THEQUEENDIED
 		},
 		{
 			"path" : "/6_chapter507returnonchild",
 			"name" : "6_chapter507returnonchild",
 			"component" : A_CHAPTER507RETURNONCHILD
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js